const badgeID = 'footer-trustbadge';
const element = document.getElementById(badgeID);

if (element) {
    const _tsid = element.dataset.id;
    window._tsConfig = {
        yOffset: 0,
        customElementId: badgeID,
        variant: 'custom_reviews',
        trustcardDirection: 'topLeft',
        customBadgeWidth: 90,
        customBadgeHeight: 90,
        disableResponsive: 'true',
        disableTrustbadge: false,
    };
    let script = document.createElement('script');
    script.charset = 'utf-8';
    script.defer = true;
    script.src = `https://widgets.trustedshops.com/js/${_tsid}.js`;
    document.head.appendChild(script);
}
